import type { EnvironmentConfigRow } from '../../devenvbootstrap/framework';

type Props = { items?: EnvironmentConfigRow[] };

export function EnvironmentConfigPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.variable} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="font-mono text-sm font-medium">{item.variable}</p>
            <div className="flex gap-1">
              {item.required && (
                <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
                  required
                </span>
              )}
              {item.secret && (
                <span className="rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-950 dark:text-amber-300">
                  secret
                </span>
              )}
            </div>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.example}</p>
        </div>
      ))}
    </div>
  );
}
